import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteReportedTime = (
    backend: string,
    token: string,
    id: number,
) => {
    return fetch(
        `${getApiUrl(backend)}reportedtimes/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default deleteReportedTime;
